module.exports = __webpack_public_path__ + "img/vertical_5_1_9005.f71a704c.png";